import { useCallback, useContext } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "../config";
import {
  IUseCreateChatProps,
  RouterNavigationMethod,
  useCreateChat,
} from "./useCreateChat";

import { useAsyncAction } from "./useAsyncAction";
import { OspApiClientContext } from "@features";
import { AGENT_CHAT_MODE } from "@/src/utils/chatMode";

// 未登录的情况下，只能存在一个会话
export const useRedirectChat = (props?: IUseCreateChatProps) => {
  const { createChatError } = props || {};
  const { onCreate, loading: chatCreateLoading } = useCreateChat({
    createChatError,
  });
  // const router = useShellRouter();
  const queryClient = useQueryClient();
  // const { isLoggedIn } = useSnapshot(rootStore.login);
  // const { data: historyData, isLoading } = useHistory();
  const { chatApi } = useContext(OspApiClientContext);
  const { run } = useAsyncAction();

  // sign标识问题具体的类型；key_type_source (问题关键字_类型_具体场景)
  const handleCheckChatVaild = useCallback(
    ({
      question,
      cacheQuestion,
      sign,
      agentId,
      setIsStartLoading,
      tpl,
      routerType = "push",
      customParams,
      senderContext = false,
    }: {
      question?: string;
      cacheQuestion?: string;
      sign?: string;
      agentId?: string;
      tpl?: string;
      setIsStartLoading?: (value: boolean) => void;
      routerType?: RouterNavigationMethod;
      customParams?: Record<string, any>;
      senderContext?: boolean;
    }) => {
      run(async () => {
        if (!chatApi || !question) {
          return;
        }
        setIsStartLoading?.(false);

        let finalCustomParams = customParams;
        if (!senderContext) {
          const isNonEntitySign = !sign || sign === "general";
          const autoChatMode = isNonEntitySign ? "qa" : AGENT_CHAT_MODE;
          finalCustomParams = { ...customParams, chatMode: autoChatMode };
        }

        if (question) {
          queryClient.invalidateQueries({
            queryKey: [QUERY_KEYS.CHAT_HISTORY],
          });
          await onCreate({
            question,
            sign,
            agentId,
            tpl,
            cacheQuestion,
            routerType,
            customParams: finalCustomParams,
          });
        }
      });
    },
    [chatApi, onCreate, queryClient, run],
  );

  return {
    handleCheckChatVaild,
    loading: chatCreateLoading,
  };
};
